export * from "./templates-carousel.component";
